import { TDrawdownRepaymentSchedule } from './repaymentSchedule.types';

/**
 * Reads the monthly repayment amount from a drawdown repayment schedule.
 *
 * Returns null when no equal-repayment amount is available.
 */
export const getMonthlyRepaymentAmount = (
    repaymentSchedule: TDrawdownRepaymentSchedule
): number | null =>
    repaymentSchedule.summary.simplified_schedule?.equal_repayments?.amount ??
    null;
